import { render, staticRenderFns } from "./globalLink.vue?vue&type=template&id=b8e04288"
import script from "./globalLink.vue?vue&type=script&lang=js"
export * from "./globalLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports